import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('cookieConfigAuto');
export const actions = helper.createActions('cookieConfigAuto', actionTypes);